import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/api.service';
import { GlobalServices } from 'src/app/global.services';

@Component({
  selector: 'app-subscribe-newsletter',
  templateUrl: './subscribe-newsletter.component.html',
  styleUrls: ['./subscribe-newsletter.component.scss']
})
export class SubscribeNewsletterComponent implements OnInit {

  constructor(
    private fb: FormBuilder,
    private httpService: ApiService,
    private globalService: GlobalServices
  ) { }

  ngOnInit(): void {
    this.emailForm = this.fb.group({
      email:[null,[Validators.required,checkValidatePssword.bind(this)]]
    })
    function checkValidatePssword(controls:AbstractControl):{passwordCheck:boolean}{
      let password = controls.value;
      if(password){
        if((password.indexOf('@')>-1) && (password.indexOf('.')>-1) && (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(password)) ){
          return null;
        }else{
          return {passwordCheck:true};
        }
      }
      return null;
    }
  }
  public showAlert: boolean = false;
  public responseMessage: string = "";
  public submitted:boolean = false;
  emailForm:FormGroup;
  subscribeNewsletterSubmit(){
    this.submitted = true;
    if (this.emailForm.valid) {
      let urlSubscribe = "global/newsletter";
      let data = { email: this.emailForm.value.email};
      this.httpService.postFormData(urlSubscribe, data).subscribe(res => {
        this.showAlert = true;
        this.responseMessage = res.message;
        if (this.globalService.isBrowser) {
          setTimeout(() => {
            this.submitted = false;
          }, 2000);
        }

      }, 
      (error: any) => {
        this.submitted = false;
      });
    } else {
      return;
    }
  }
  public triggerCloseEvent() {
    this.showAlert = false;
  }
  get f(){return this.emailForm.controls;}
}
